"use strict";

require("core-js/modules/es.array.iterator");

var curry = require("./curry.js");

var go = require("./go.js");

var go1 = require("./go1.js");

var entries = require("./entries.js");

var map = require("./map.js");

var reduce = require("./reduce.js");

var pipe = require("./pipe.js");

var reverse1 = require("../.internal/reverse1.js");

const invertBy = curry((f, obj) => go(obj, entries, map(pipe(reverse1, ([k, v]) => go1(f(k, v), _k => [_k, v]))), iter => reduce((acc, [k, v]) => ((acc[k] || (acc[k] = [])).push(v), acc), {}, iter)));
module.exports = invertBy;